import Clear from '@/layouts/Clear.vue';

export default {
  path: '/models',
  component: Clear,
  children: [
    {
      path: '',
      name: 'models',
      component: () => import('@/views/Models.vue'),
    },
  ],
};
